(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BlackfridayPopup"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('iao-black-friday')) return;
  class InAndOnBlackFriday extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.dialog.id = `iao-bf-dialog-${this.dataset.sectionId}`;
      this.editor = Boolean(window.Shopify && window.Shopify.designMode);
      this.launcher = this.querySelector('[data-bf-open]');
      this.storageKey = `iao-bf:${this.dataset.campaign || 'black-friday-2026'}:${this.dataset.code}`;
      this.makeShopLink();
      this.querySelectorAll('[data-bf-close]').forEach(button => button.addEventListener('click', () => this.close(), { signal }));
      this.launcher?.addEventListener('click', () => this.open(), { signal });
      this.querySelector('[data-bf-copy]').addEventListener('click', () => this.copy(), { signal });
      this.querySelector('[data-bf-shop]').addEventListener('click', () => { this.remember(); this.close(); }, { signal });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, { signal });
      this.dialog.addEventListener('close', () => this.afterClose(), { signal });
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const items = [...this.dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]')].filter(element => element.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, { signal });
      const outside = event => {
        const rect = this.dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      };
      this.dialog.addEventListener('pointerdown', event => { this.backdropDown = event.target === this.dialog && outside(event); }, { signal });
      this.dialog.addEventListener('click', event => {
        if (this.backdropDown && event.target === this.dialog && outside(event)) this.close();
        this.backdropDown = false;
      }, { signal });
      document.addEventListener('shopify:section:select', event => {
        if (this.editor && event.detail.sectionId === this.dataset.sectionId) this.open();
      }, { signal });
      document.addEventListener('shopify:section:deselect', event => {
        if (this.editor && event.detail.sectionId === this.dataset.sectionId) this.close();
      }, { signal });
      if (!this.editor && this.dataset.enabled !== 'true') return;
      if (this.launcher) this.launcher.hidden = false;
      if (this.editor) {
        if (this.dataset.preview === 'true') this.timer = setTimeout(() => this.open(), 350);
        return;
      }
      const hours = Number(this.dataset.repeat) || 24;
      const age = Date.now() - this.lastSeen();
      if (age >= hours * 3600000 || age < 0) {
        this.timer = setTimeout(() => this.autoOpen(), Math.max(0, Number(this.dataset.delay) || 4) * 1000);
      }
    }
    autoOpen() {
      if (!this.isConnected) return;
      // Do not interrupt an inactive tab or another open dialog/cart interaction.
      const otherModal = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')].some(element => {
        const rect = element.getBoundingClientRect();
        const style = getComputedStyle(element);
        return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) !== 0 && rect.right > 0 && rect.left < innerWidth && rect.bottom > 0 && rect.top < innerHeight;
      });
      if (document.hidden || otherModal) {
        this.timer = setTimeout(() => this.autoOpen(), 1500);
        return;
      }
      this.open();
    }
    readStorage(storage) {
      try { return Number(window[storage].getItem(this.storageKey)) || 0; } catch (_) { return 0; }
    }
    lastSeen() {
      return Math.max(this.readStorage('localStorage'), this.readStorage('sessionStorage'), InAndOnBlackFriday.seen.get(this.storageKey) || 0);
    }
    remember() {
      if (this.editor) return;
      const now = Date.now();
      InAndOnBlackFriday.seen.set(this.storageKey, now);
      for (const storage of ['localStorage', 'sessionStorage']) {
        try { window[storage].setItem(this.storageKey, String(now)); } catch (_) { /* Private mode must not break the popup. */ }
      }
    }
    open() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.dialog.open) return;
      if (document.querySelector('iao-black-friday dialog[open]')) return;
      this.querySelectorAll('[data-bf-src]').forEach(image => {
        if (!image.src) image.src = image.dataset.bfSrc;
      });
      this.previousFocus = document.activeElement;
      this.dialog.showModal(); // Native modal: top layer, background inert, keyboard focus contained.
      this.lockScroll();
      if (this.launcher) this.launcher.hidden = true;
      this.remember();
      this.querySelector('[data-bf-close]').focus({ preventScroll: true });
    }
    close() {
      clearTimeout(this.timer);
      if (this.dialog?.open) { this.remember(); this.dialog.close(); }
      this.afterClose();
    }
    lockScroll() {
      if (this.savedOverflow) return;
      const style = document.documentElement.style;
      this.savedOverflow = [style.getPropertyValue('overflow'), style.getPropertyPriority('overflow')];
      style.setProperty('overflow', 'hidden', 'important');
    }
    afterClose() {
      if (this.dialog?.open) return;
      if (this.savedOverflow) {
        const [value, priority] = this.savedOverflow;
        if (value) document.documentElement.style.setProperty('overflow', value, priority);
        else document.documentElement.style.removeProperty('overflow');
        this.savedOverflow = null;
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }
      if (this.launcher && this.isConnected) this.launcher.hidden = false;
    }
    makeShopLink() {
      const origin = window.location.origin;
      const root = new URL(this.dataset.root || '/', origin).pathname.replace(/\/$/, '');
      let target;
      try { target = new URL(this.dataset.target || `${root}/collections/all`, origin); } catch (_) { target = new URL(`${root}/collections/all`, origin); }
      // Only redirect within this storefront. Locale prefixes come from Shopify, not guesses.
      if (target.origin !== origin) target = new URL(`${root}/collections/all`, origin);
      let path = target.pathname;
      let roots = [];
      try { roots = JSON.parse(this.dataset.languageRoots || '[]'); } catch (_) { /* Use current root. */ }
      if (!Array.isArray(roots)) roots = [];
      roots = [...new Set([...roots, root].filter(Boolean).map(value => String(value).replace(/\/$/, '')).filter(Boolean))].sort((a, b) => b.length - a.length);
      for (const prefix of roots) {
        if (path === prefix || path.startsWith(`${prefix}/`)) { path = path.slice(prefix.length) || '/'; break; }
      }
      const redirect = `${root}${path.startsWith('/') ? path : `/${path}`}${target.search}${target.hash}`;
      this.querySelector('[data-bf-shop]').href = `${origin}/discount/${encodeURIComponent(this.dataset.code)}?redirect=${encodeURIComponent(redirect)}`;
    }
    async copy() {
      const button = this.querySelector('[data-bf-copy]');
      const status = this.querySelector('[data-bf-status]');
      const field = this.querySelector('.iao-bf__code');
      let copied = false;
      try {
        if (navigator.clipboard && window.isSecureContext) { await navigator.clipboard.writeText(this.dataset.code); copied = true; }
      } catch (_) { /* Fall back to a selectable field in the active dialog. */ }
      if (!copied) {
        field.focus({ preventScroll: true }); field.select(); field.setSelectionRange(0, field.value.length);
        try { copied = document.execCommand('copy'); } catch (_) { copied = false; }
      }
      if (!this.isConnected) return;
      button.textContent = copied ? this.dataset.copied : this.dataset.copy;
      button.classList.toggle('is-copied', copied);
      status.textContent = copied ? this.dataset.copied : this.dataset.copyError;
      if (copied) button.focus({ preventScroll: true });
      clearTimeout(this.copyTimer);
      if (copied) this.copyTimer = setTimeout(() => {
        button.textContent = this.dataset.copy; button.classList.remove('is-copied'); status.textContent = '';
      }, 2200);
    }
    disconnectedCallback() {
      clearTimeout(this.timer); clearTimeout(this.copyTimer);
      this.controller?.abort(); this.controller = null;
      if (this.dialog?.open) this.dialog.close();
      this.afterClose();
    }
  }
  InAndOnBlackFriday.seen = new Map();
  customElements.define('iao-black-friday', InAndOnBlackFriday);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
